<template>
  <RepairNetworkHost />
</template>
<script>
import RepairNetworkHost from '@/components/dashboard/RepairNetworkHost.vue'
export default {
  name: 'RepairNetworkView',
  components: {
    RepairNetworkHost
  }
}
</script>
<style lang="scss" scoped></style>
